<template>
  <div class="welcome-back">
    <open-fund-header show-shopping-cart/>
    <div class="r-text-intro">היי {{this.firstName}}, שמחים שחזרת!</div>
    <div class="r-text-headline-paragraph">שנמשיך מאיפה שעצרת?</div>
    <default-button label="כן! אפשר להמשיך" @click="moveToOpenFund"/>
  </div>

</template>

<script>
import { mapState } from 'vuex';
import DefaultButton from '@/components/styled/DefaultButton';
import OpenFundHeader from '@/components/meitav-dash/OpenFundHeader';

export default {
  name: 'WelcomeBack',
  components: { DefaultButton, OpenFundHeader },
  computed: {
    ...mapState('meitavDash/openFund', ['firstName']),
  },
  methods: {
    async moveToOpenFund() {
      await this.$router.push({ path: '/meitav/open-fund' });
    },
  },
};
</script>
